import { forwardRef } from 'react';

import { StyledToggleButton } from './ToggleButton.styled';
import type { ToggleButtonProps } from './types';

const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  (
    {
      color = 'tertiary',
      variant = 'solid',
      selected = false,
      onSelectedChange,
      startIcon,
      endIcon,
      onClick,
      children,
      ...rest
    },
    ref,
  ) => {
    const handleClick: ToggleButtonProps['onClick'] = (event) => {
      onClick?.(event);
      if (!event.defaultPrevented) onSelectedChange?.(!selected);
    };

    return (
      <StyledToggleButton
        ref={ref}
        $selected={selected}
        $variant={variant}
        color={selected ? color : 'tertiary'}
        variant={selected ? variant : 'outline'}
        aria-pressed={selected}
        onClick={handleClick}
        {...rest}
      >
        {startIcon}
        {children}
        {endIcon}
      </StyledToggleButton>
    );
  },
);

ToggleButton.displayName = 'ToggleButton';

export default ToggleButton;
